/* eslint-disable max-lines -- checkout footer analytics catalogue; keep related events in one module */
import { CLICK_ACTIONS, IMPRESSION_ACTIONS, SCREEN_NAME } from "../constants";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";
import { isEmpty } from "@swiggy-private/js-utils";
export const clickProceedToPay = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    payload: { cartAmount: number; restaurantId?: string | number; context?: string; groupCartId?: string },
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_PROCEED_TO_PAY,
        label: payload.restaurantId,
        value: payload.cartAmount,
        context: payload.context,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        extraParams: JSON.stringify({ grp_cart_id: payload.groupCartId }),
    });
};

export const clickLogin = (cartAmount: number, clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_LOGIN,
        value: cartAmount,
    });
};

export const clickAddAddress = (
    {
        cartTotal,
        addressesAndNudgeContext,
        nudgeText,
        cartIDs,
    }: {
        cartTotal: number;
        addressesAndNudgeContext: string;
        nudgeText: string;
        cartIDs: string;
    },
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_ADD_ADDRESS,
        value: cartTotal,
        label: nudgeText,
        context: addressesAndNudgeContext,
        extraParams: cartIDs,
    });
};

export const clickChangeAddress = (
    {
        cartAmount,
        cartStatusAndAddressesContext,
        cartIDs,
    }: { cartAmount: number; cartStatusAndAddressesContext: string; cartIDs: string },
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_CHANGE_ADDRESS,
        value: cartAmount,
        context: cartStatusAndAddressesContext,
        extraParams: cartIDs,
    });
};

export const clickClearCart = (cartAmount: number, clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_CLEAR_CART,
        value: cartAmount,
    });
};

export const clickViewDetailedBill = (cartAmount: number, clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_VIEW_DETAILED_BILL,
        value: cartAmount,
    });
};

export const clickSelectAddress = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    {
        nudgeText,
        addressesAndNudgeContext,
        cartIDs,
    }: {
        nudgeText: string;
        addressesAndNudgeContext: string;
        cartIDs: string;
    },
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_ADDRESS_SELECT,
        label: nudgeText,
        context: addressesAndNudgeContext,
        extraParams: cartIDs,
    });
};

export const clickViewSimilarRestaurantCTA = ({
    clickEvent,
    actionName,
    statusCode,
    context,
}: {
    clickEvent: AnalyticsContextValue["clickEvent"];
    actionName:
        | typeof CLICK_ACTIONS.CLICK_VIEW_SIMILAR_CTA_GOTOHOME
        | typeof CLICK_ACTIONS.CLICK_VIEW_SIMILAR_CTA_GOTOCOLLECTIONS;
    statusCode: number;
    context: string;
}): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: actionName,
        label: statusCode,
        context,
    });
};

export const impressionViewSimilarRestaurantCTA = ({
    impressionEvent,
    context,
    actionName,
    statusCode,
}: {
    impressionEvent: AnalyticsContextValue["impressionEvent"];
    context: string;
    actionName:
        | typeof IMPRESSION_ACTIONS.IMPRESSION_VIEW_SIMILAR_CTA_GOTOHOME
        | typeof IMPRESSION_ACTIONS.IMPRESSION_VIEW_SIMILAR_CTA_GOTOCOLLECTIONS;
    statusCode: number;
}): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: actionName,
        label: statusCode,
        context,
    });
};

export const impressionViewSimilarRestaurantCTAMRO = ({
    impressionEvent,
    parentCartId,
    cartId,
}: {
    impressionEvent: AnalyticsContextValue["impressionEvent"];
    parentCartId?: number | string;
    cartId?: number | string;
}): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_VIEW_SIMILAR_CTA_GOTOHOME,
        context: JSON.stringify({
            // eslint-disable-next-line @typescript-eslint/naming-convention
            parent_cart_id: parentCartId,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            cart_id: cartId,
        }),
    });
};

export const clickSelectDeliverySlot = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    restaurantId?: number | string | undefined,
    context?: string,
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_SELECT_DELIVERY_SLOT_BUTTON,
        label: restaurantId,
        context,
    });
};

export const clickDropptDeliverySlot = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    restaurantId?: number | string | undefined,
    context?: string,
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_DROPPT_DELIVERY_SLOT,
        label: restaurantId,
        context,
    });
};

export const impressionProceedToPay = ({
    impressionEvent,
    context,
    restaurantId,
}: {
    impressionEvent: AnalyticsContextValue["impressionEvent"];
    context?: string;
    restaurantId?: number | string | undefined;
}): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_PROCEED_TO_PAY,
        label: restaurantId,
        context,
    });
};
export const impressionSelectDeliverySlot = ({
    impressionEvent,
    context,
    restaurantId,
}: {
    impressionEvent: AnalyticsContextValue["impressionEvent"];
    context?: string;
    restaurantId?: number | string | undefined;
}): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_SELECT_DELIVERY_SLOT_BUTTON,
        label: restaurantId,
        context,
    });
};
export const impressionDelierySlots = ({
    impressionEvent,
    context,
    restaurantId,
}: {
    impressionEvent: AnalyticsContextValue["impressionEvent"];
    context?: string;
    restaurantId?: number | string | undefined;
}): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_DROPPT_DELIVERY_SLOT,
        label: restaurantId,
        context,
    });
};

export const onImpressionProceedToPay = (
    couponApplied: boolean,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    cartContextForAnalytics: Record<string, unknown> = {},
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_PROCEED_TO_PAY_TURBO,
        label: String(couponApplied),
        ...(!isEmpty(cartContextForAnalytics) ? { context: JSON.stringify(cartContextForAnalytics) } : {}),
    });
};

export const onWebcartUpdateImpression = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    context: Record<string, string | boolean | number | undefined>,
    groupCartId?: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_CART_PAGE_UPDATED,
        context: JSON.stringify(context),
        // eslint-disable-next-line @typescript-eslint/naming-convention
        extraParams: JSON.stringify({ grp_cart_id: groupCartId }),
    });
};

export const clickAddMoreItemsCTA = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    restaurantId?: number | string | undefined,
    context?: string,
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_OCASSIONS_ADD_MORE_ITEMS_BUTTON,
        label: restaurantId,
        context,
    });
};

export const clickOcassionsViewMoreOutletsCTA = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    restaurantId?: number | string | undefined,
    context?: string,
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_OCASSIONS_VIEW_MORE_OUTLETS_BUTTON,
        label: restaurantId,
        context,
    });
};

export const clickOcassionsProceedToPayCTA = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    restaurantId?: number | string | undefined,
    context?: string,
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_OCASSIONS_PROCEED_TO_PAY_BUTTON,
        label: restaurantId,
        context,
    });
};

export const onImpressionOcassionsProceedToPay = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    context: string,
    restaurantId?: number | string | undefined,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_OCASSIONS_PROCEED_TO_PAY_BUTTON,
        label: String(restaurantId),
        context,
    });
};

export const impressionFlipkartInstalled = (impressionEvent: AnalyticsContextValue["impressionEvent"]): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_FLIPKART_INSTALLED,
    });
};

export const clickAddressChangeBack = (clickEvent: AnalyticsContextValue["clickEvent"], cartIDs: string): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_ADDRESS_CHANGE_BACK,
        extraParams: cartIDs,
    });
};
